import { AspectRatio } from "@bpba/ui-components";
import styled from "styled-components";
import { border, BorderProps } from "styled-system";

type BannerProps = BorderProps & { url: string | undefined };

const StyledImg = styled.img<BannerProps>(border, (props) => ({
  src: props.url,
}));

export const Banner = (props: BannerProps) => {
  if (!props || !props.url) return <></>;

  return (
    <AspectRatio ratio={5.12}>
      <StyledImg {...props} alt="banner" src={props.url} />
    </AspectRatio>
  );
};